import React from "react";
import BoxFrame from "../BoxFrame";
import { FrameTitle, FrameContent } from "../style";
import { Wrapper } from "./style";
import { useTranslation } from "react-i18next";

const TransactionalData = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <BoxFrame alignImage="left" dataImage="./images/TransactionalData.svg">
        <FrameTitle>{t("transactionalData.title")}</FrameTitle>
        <FrameContent>
          <p>{t("transactionalData.desc1")}</p>
          <p>{t("transactionalData.desc2")}</p>
          <p>{t("transactionalData.desc3")}</p>
        </FrameContent>
      </BoxFrame>
    </Wrapper>
  );
};

export default TransactionalData;
